export default __webpack_public_path__ + "static/media/radiant-bright-purple-red.6ad5c96a.jpg";